import React, { useCallback, useState, useEffect, Fragment, useContext } from 'react';
import Button from '../bronson/Button';
import Traductor from '../Traductor';
import { VehiclesContext } from '../../contexts/VehiclesContext';
import {
    formatPrice,
    formatNumber,
} from '../../js/components/shared/vehicleFunctions';
import Globals from '../../Globals';
import { withCookies } from 'react-cookie';
import '../../css/components/shared/vehicleCard/VehicleCard.css';
import Tag from '../bronson/Tag';
import Carousel from '../bronson/Carousel';
import {
    isAppleDeviceOrNavegatorForDates,
    getImageSource,
    getCookie,
} from '../../Functions';

import SellService from '../../services/SellService';
import { Portal } from 'react-portal';
import DetailsModal from '../batches/Details/DetailsModal';
import DateInput from '../ticketing/common/DateInput';

function VehicleSoldVWRCard({ cookies, vehicleParent, selectedDetail }) {
    const t = new Traductor();
    const { setSelectedVehicle } = useContext(VehiclesContext);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [vehicle] = useState(vehicleParent);

    const [error, setError] = useState();
    const [loading, setLoading] = useState();
    const [modalDocuments, setModalDocuments] = useState(false);
    const [modalPickup, setModalPickup] = useState(false);
    const [pickupDate, setPickupDate] = useState(isAppleDeviceOrNavegatorForDates(new Date()).toLocaleDateString('en-GB'));
    const [values, setValues] = useState({pickupDate: isAppleDeviceOrNavegatorForDates(new Date()).toLocaleDateString('en-GB')});
    const [docsForSale, setdocsForSale] = useState(null)

    let optionsDownloadInvoiceVWR = {
        id: vehicle.Plate + t.getTraduction('DownloadInvoiceVWR'),
        text: t.getTraduction('DownloadInvoiceVWR'),
        class: 'c-btn c-btn--full ',
        name: 'Bill',
                    type: 'button',
                    icon: {
                        title: 'download',
                        image: 'semantic-download',
                        isAfterText: true,
                    },
        loading: loading === vehicle.Plate + t.getTraduction('DownloadInvoiceVWR'),
        //disabled: vehicle.PayDateVWR != null ? false : true,
        disabled: true,
    };

    let optionsSchedulePickup = {
        id: vehicle.Plate + t.getTraduction('AddRemovalDate'),
        text: t.getTraduction('AddRemovalDate'),
        class: 'c-btn c-btn--full ',
        name: 'Bill',
                    type: 'button',
                    
        loading: loading === vehicle.Plate + t.getTraduction('AddRemovalDate'),
        disabled: vehicle.PickupPermission ? false : true,
    };


    let optionsDownoadTransferDocuments = {
        id: vehicle.Plate + t.getTraduction('DownloadDocuments'),
        text: t.getTraduction('DownloadDocuments'),
        class: 'c-btn c-btn--full ',
        loading: loading === vehicle.Plate + t.getTraduction('DownloadDocuments'),
        disabled: vehicle.PayDateBank != null ? false : true,
    };
    
    let optionsDownoadDeliveryCertificate = {
        id: vehicle.Plate + t.getTraduction('DeliveryCertificate'),
        text: t.getTraduction('SendDeliveryCertificateByEmail'), 
        class: 'c-btn  c-btn--secondary  c-btn--icon u-mr',
        icon: {
            title: 'download',
            image: 'semantic-mail',
            isAfterText: true,
        },
        loading: loading === vehicle.Plate + t.getTraduction('DeliveryCertificate'),
        disabled: vehicle.PayDateBank != null ? false : true,
    };

    useEffect(() => {
        window.addEventListener('resize', getWindowWitdh);
    }, []);

    const getWindowWitdh = () => {
        setWindowWidth(window.innerWidth);
    };

    const openPickupModal = () => {
        setModalPickup(true);
    };

    const printModalPickup = () => {
        let html = null;
        html=(
            <Fragment>
                           <DateInput
                                label=""
                                row
                                values={values}
                                name="pickupDate"
                                onChange={handleChange}                                
                            />
                             <Button
                            options={
                                {
                                    id: vehicle.Plate + t.getTraduction('RemovalDate'),
                                    text: t.getTraduction('AddRemovalDate'), 
                                    class: 'c-btn c-btn--full ',
                                    disabled: loading === vehicle.Plate + t.getTraduction('RemovalDate') + "button", 
                                    loading: loading === vehicle.Plate + t.getTraduction('RemovalDate') + "button",                               
                                }
                            }
                            onClick={() =>
                                savePickupDate()
                            }
                        ></Button>
            </Fragment>
         );
        return (
            <DetailsModal
                                        visible={modalPickup}
                                        large={false}
                                        onActionPress={() => setModalPickup(false)}
                                        onClose={() => setModalPickup(false)}
                                        title={t.getTraduction('RemovalDate')}
                                        content={html}
                                        leftButton={t.getTraduction('Close')}
                                    />
        );
    };

    const openDocumentModal = () => {
        //getDocsForSale();
        setModalDocuments(true);
    };

    const handleChange = (event,value) => {
        values[event]=value;
        setPickupDate(value);
      };


      const sendEmailDelivery = async () => {
        setLoading(vehicle.Plate + t.getTraduction('DeliveryCertificate'));
        let data = {
            VehicleId: vehicle.Id,
            UserName:getCookie(process.env.REACT_APP_USER_ID)
        };
        await new SellService()
            .sendEmailDeliveryCertificate(
                data,
                cookies.get(Globals.COOKIES.JWT).AccessToken
            )
            .then(response => {
                if (
                    response &&
                    response.statusCode == 200 &&
                    response.body.Result != null &&
                    response.body.Result == 'true'
                ) {
                    alert("Acta de entrega enviada a email.")                   
                } else {
                    if (
                        response &&
                        response.body &&
                        response.body.Errors &&
                        response.body.Errors.length > 0
                    ) {
                        alert(response.body.Errors[0].Value);
                    } else {
                        alert("Error en envio de acta por email.");                       
                    }
                }
            });   
            setLoading(false);     
    };

    const savePickupDate = async () => {
        setLoading(vehicle.Plate + t.getTraduction('RemovalDate') + "button");
        let data = {
            VehicleId: vehicle.Id,
            Date: pickupDate
        };
        await new SellService()
            .updatePickupDate(
                data,
                cookies.get(Globals.COOKIES.JWT).AccessToken
            )
            .then(response => {
                if (
                    response &&
                    response.statusCode == 200 &&
                    response.body.Result != null &&
                    response.body.Result == 'true'
                ) {
                    alert(t.getTraduction('RemovalDate') + " modificada correctamente")
                    window.location.reload();
                } else {
                    if (
                        response &&
                        response.body &&
                        response.body.Errors &&
                        response.body.Errors.length > 0
                    ) {
                        alert(response.body.Errors[0].Value);
                    } else {
                        alert(true);
                        window.location.reload();
                    }
                }
            });
        setLoading(false);
    };

    const ConvertRegister = useCallback(items => {
        const array = [];
        const ass = items?.forEach(x => {
            const obj = {};
            obj.DocumentId = x.DocumentId;
            obj.FileName = x.FileName;
            array.push(obj);
        });
        return array;
    });

    const printModalDocuments = () => {
        let html = null;
        html=(
            <Fragment>
                 <div className="o-layout o-layout--equal-height u-p-none">
               <div className="o-layout__item u-1/1 u-p-none u-mt-none">
                        <Button
                            options={optionsDownoadDeliveryCertificate}
                            onClick={() =>
                                sendEmailDelivery()                             
                            }
                        ></Button>
            </div>
<hr/>

{ConvertRegister(docsForSale)?.map(function(data,i) {
      return (
        <div  key={i} className="o-layout__item u-1/1 u-p-none u-mt-none">    
        <Button
                            options={
                                {
                                    id: "SaleDoc"+ data.DocumentId,
                                    text: data.FileName,
                                    class: 'c-btn  c-btn--secondary  c-btn--icon u-mr',
                                    disabled: false,
                                    icon: {
                                        title: 'download',
                                        image: 'semantic-download',
                                        isAfterText: true,
                                    },
                                    loading: loading === vehicle.Plate + data.DocumentId,
                                }
                            }
                            onClick={() =>
                                dowloadSaleDocument(data.DocumentId)
                            }
                        ></Button>        
        </div>              
      )
    })}    

</div>
            </Fragment>
         );
        return (
            <DetailsModal
                                        visible={modalDocuments}
                                        large={false}
                                        onActionPress={() => setModalDocuments(null)}
                                        onClose={() => setModalDocuments(null)}
                                        title={t.getTraduction('TransferDocuments')}
                                        content={html}
                                        leftButton={t.getTraduction('Close')}
                                    />
        );
    };


    const printCardTag = (mobile = false) => {
        let text = null;
        let className = ['c-vehicle-card__tag-payment-status'];

        if (mobile) {
            if (vehicle.PayDateVWR === null || vehicle.PayDateVWR === '') {
                text = t.getTraduction('Pending');
                className = ['error'];
            }
        } else {
            if (windowWidth > 720) {
                if (vehicle.PayDateBank == null) {
                    text = t.getTraduction('AdjudicatedOutstandingBank');
                    className.push('error');
                } 
                else if (vehicle.PayDateVWR == null)
                {
                    text = t.getTraduction('SoldVWROutstandng');
                    className.push('error');
                } 
                else if(vehicle.PayDateVWR != null){
                    text = t.getTraduction('SoldVWRPayed');
                    className.push('success');
                }
            }
        }

        if (text == null) return null;
        return <Tag classes={className} text={text}></Tag>;
    };

    const setSelectedDetail = () => {
        selectedDetail(vehicle);
        setSelectedVehicle(vehicle);
    };


    const getDocsForSale = async () => {
        setSelectedVehicle(vehicle);
        setLoading(vehicle.Plate + t.getTraduction('DownloadDocuments'));        
        try {
                const response = await new SellService().getDocumentsForSale(
                    cookies.get(Globals.COOKIES.JWT).AccessToken,
                    {
                        VehicleId: vehicle.Id,
                    }
                );
                if (response) {
                    var model = JSON.parse(JSON.parse(response.body).Result);
                    console.log(model);
                    setdocsForSale(model);
                }
            } catch (error) {
                setdocsForSale(null);
                
            } finally {
                setLoading(null);
                setModalDocuments(true);
            }
    };

    const dowloadSaleDocument = async (Id) => {
        setSelectedVehicle(vehicle);
        setLoading(vehicle.Plate + Id);        
        try {
                const response = await new SellService().getDocumentForSaleById(
                    cookies.get(Globals.COOKIES.JWT).AccessToken,
                    {
                        DocumentId: Id,
                    }
                );
                if (response) {
                    var model = JSON.parse(JSON.parse(response.body).Result);
                    console.log(model);
                    var sliceSize = 2000;
                    var byteCharacters = window.atob(model.File);
                    var byteArrays = [];
                    var typeFile="application/pdf";
                    var signatures = {
                        JVBERi0: "application/pdf",
                        R0lGODdh: "image/gif",
                        R0lGODlh: "image/gif",
                        iVBORw0KGgo: "image/png",
                        TU0AK: "image/tiff",
                        "/9j/": "image/jpg"
                      };
            
                        for (var s in signatures) 
                        {
                            if (model.File.indexOf(s) === 0) 
                            {
                                var x = signatures[s];
    
                                typeFile=x;
                                break;
                            }
                        }
                    for (
                        var offset = 0;
                        offset < byteCharacters.length;
                        offset += sliceSize
                    ) {
                        var slice = byteCharacters.slice(
                            offset,
                            offset + sliceSize
                        );
                        var byteNumbers = new Array(slice.length);

                        for (var i = 0; i < slice.length; i++) {
                            byteNumbers[i] = slice.charCodeAt(i);
                        }
                        var byteArray = new Uint8Array(byteNumbers);
                        byteArrays.push(byteArray);
                    }
                    var blob = new Blob(byteArrays, {
                        type: typeFile,
                    });
                    var fileURL = URL.createObjectURL(blob);
                    var a = document.createElement('a');
                    document.body.appendChild(a);
                    a.style = 'display: none';
                    a.href = fileURL;
                    a.download = 'Documento para venta -' + vehicle.Plate + '.pdf';
                    a.click();
                    window.URL.revokeObjectURL(fileURL);
                    a.remove();
                }
            } catch (error) {
                setError({
                    Content: t.getTraduction('SaleDocumentDownloadError')(
                        vehicle.Plate
                    ),
                });
            } finally {
                setLoading(null);
            }
    };

    const dowloadInvoiceVWR = async () => {
        setSelectedVehicle(vehicle);
        setLoading(vehicle.Plate + t.getTraduction('DownloadInvoiceVWR'));        
        try {
                const response = await new SellService().getBillVehicleSoldVWR(
                    cookies.get(Globals.COOKIES.JWT).AccessToken,
                    {
                        NIF: vehicle.BuyerNumDocument,
                        Plate: vehicle.Plate,
                    }
                );
                if (response) {
                    var model = JSON.parse(JSON.parse(response.body).Result);
                    var sliceSize = 2000;
                    var byteCharacters = window.atob(model.File);
                    var byteArrays = [];

                    for (
                        var offset = 0;
                        offset < byteCharacters.length;
                        offset += sliceSize
                    ) {
                        var slice = byteCharacters.slice(
                            offset,
                            offset + sliceSize
                        );
                        var byteNumbers = new Array(slice.length);

                        for (var i = 0; i < slice.length; i++) {
                            byteNumbers[i] = slice.charCodeAt(i);
                        }
                        var byteArray = new Uint8Array(byteNumbers);
                        byteArrays.push(byteArray);
                    }
                    var blob = new Blob(byteArrays, {
                        type: 'application/pdf',
                    });
                    var fileURL = URL.createObjectURL(blob);
                    var a = document.createElement('a');
                    document.body.appendChild(a);
                    a.style = 'display: none';
                    a.href = fileURL;
                    a.download = 'Factura-' + vehicle.Plate + '.pdf';
                    a.click();
                    window.URL.revokeObjectURL(fileURL);
                    a.remove();
                }
            } catch (error) {
                setError({
                    Content: t.getTraduction('BillDownloadError')(
                        vehicle.Plate
                    ),
                });
            } finally {
                setLoading(null);
            }
    };


    const printCardTitles = () => {
        let className = 'u-1/1 u-mt u-mb-small u-pl u-pr';
        if (windowWidth > 720) {
            className = 'u-9/12 u-m-none u-p-none';
        }
        return (
            <div
                className={'o-layout__item ' + className}
                onClick={() => setSelectedDetail()}
            >
                <p className="c-card__title">
                    {vehicle.Plate}
                    {vehicle.BrandName ? ' - ' + vehicle.BrandName : ''}
                </p>
            </div>
        );
    };

    const printVehicleDates = (mobile = false) => {
        let html = null;

        if (!mobile && windowWidth >= 720) {
            html = (
                <div className="o-layout__item u-1/1 u-m-none u-pl-none">
                    <ul className="list-inline">
                        <li className="list-inline__item">
                            <p className="u-m-none">
                                <span className="u-text-disabled">
                                    {t.getTraduction('BuyDateBank')}:{' '}
                                </span>
                                <span>
                                    {vehicle.PayDateBank
                                        ? new Date(
                                              isAppleDeviceOrNavegatorForDates(
                                                  vehicle.PayDateBank
                                              )
                                          ).toLocaleDateString('en-GB')
                                        : '--'}
                                </span>
                            </p>
                        </li>
                        <li className="list-inline__item">
                            <p className="u-m-none">
                                <span className="u-text-disabled">
                                    {t.getTraduction('PayDateVWR')}:{' '}
                                </span>
                                <span>
                                    {vehicle.PayDateVWR
                                        ? new Date(
                                              isAppleDeviceOrNavegatorForDates(
                                                  vehicle.PayDateVWR
                                              )
                                          ).toLocaleDateString('en-GB')
                                        : '--'}
                                </span>
                            </p>
                        </li>
                        <li className="list-inline__item">
                            <p className="u-m-none">
                                <span className="u-text-disabled">
                                    {t.getTraduction('RemovalDate')}:{' '}
                                </span>
                                <span>
                                    {vehicle.RemovalDate
                                        ? new Date(
                                              isAppleDeviceOrNavegatorForDates(
                                                  vehicle.RemovalDate
                                              )
                                          ).toLocaleDateString('en-GB')
                                        : '--'}
                                </span>
                            </p>
                        </li>
                    </ul>
                </div>
            );
        } else {
            if (mobile && windowWidth < 720) {
                html = (
                    <div className="o-layout__item u-1/1 u-mt-small">
                        <ul className="list-inline list-inline--mobile-block">
                            <li className="list-inline__item">
                                <p className="u-m-none">
                                    <span className="u-text-disabled">
                                        {t.getTraduction('BuyDateBank')}{' '}
                                    </span>
                                    <span className="u-block u-mt-xsmall">
                                        {vehicle.PayDateBank
                                            ? new Date(
                                                  isAppleDeviceOrNavegatorForDates(
                                                      vehicle.PayDateBank
                                                  )
                                              ).toLocaleDateString('en-GB')
                                            : '--'}
                                    </span>
                                </p>
                            </li>
                            <li className="list-inline__item">
                                <div className="u-m-none">
                                    {vehicle.PayDateVWR ? (
                                        <Fragment>
                                            <p className="u-text-disabled u-mb-xsmall">
                                                {t.getTraduction('PayDateVWR')}{' '}
                                            </p>
                                            <span className="u-block u-mt-xsmall">
                                                {vehicle.PayDateVWR
                                                    ? new Date(
                                                          isAppleDeviceOrNavegatorForDates(
                                                              vehicle.PayDateVWR
                                                          )
                                                      ).toLocaleDateString('en-GB')
                                                    : '--'}
                                            </span>
                                        </Fragment>
                                    ) : (
                                        <Fragment>
                                            <p className="u-text-disabled u-mb-xsmall">
                                                {t.getTraduction('PayState')}
                                            </p>
                                            {printCardTag(true)}
                                        </Fragment>
                                    )}
                                </div>
                            </li>
                        </ul>
                    </div>
                );
            }
        }
        return html;
    };

    const printSellRegimeData = () => {
        let html = null;
        if (windowWidth >= 720 && windowWidth < 1280) {
            html = (
                <Fragment>
                    <div className="o-layout__item u-1/1 u-p-none u-mt-none">
                        <p className="u-mb-xsmall">
                            <span className="u-text-disabled">
                                {t.getTraduction('SalesRegime')}:
                            </span>{' '}
                            {vehicle.SaleVWRType =='REBU'
                                ? t.getTraduction('REBU')
                                : t.getTraduction('REG')}
                        </p>
                    </div>
                </Fragment>
            );
        } else {
            html = (
                <Fragment>
                    <div className="o-layout__item u-1/2 u-p-none u-mt-none">
                        <p className="u-mb-xsmall">
                            <span className="u-text-disabled">
                                {t.getTraduction('SalesRegime')}
                            </span>
                        </p>
                        <p className="u-mb-xsmall">
                        {vehicle.SaleVWRType =='REBU'
                                ? t.getTraduction('REBU')
                                : t.getTraduction('REG')}
                        </p>
                    </div>
                </Fragment>
            );
        }

        return html;
    };

    const printBuyBAnkDetailsData = () => {
        let html = null;
            html = (
                <Fragment>
                    <div className="o-layout__item u-1/2 u-p-none u-mt-none">
                        <p className="u-text-disabled u-mb-xsmall rema-text-overflow--ellipsis">
                            <span className="u-text-disabled">
                                {t.getTraduction('VehiclePrice')}
                            </span>
                        </p>
                        <p className="u-mb-xsmall">{formatPrice(vehicle.VMG)}</p>
                    </div>
                    <div className="o-layout__item u-1/2 u-p-none u-mt-none">
                        <p className="u-text-disabled u-mb-xsmall rema-text-overflow--ellipsis">
                            <span className="u-text-disabled">
                                {t.getTraduction('DamagesToReturn')}
                            </span>
                        </p>
                        <p className="u-mb-xsmall">{formatPrice(vehicle.TotalDamageAmount)}</p>
                    </div>
                </Fragment>
            );       
        return html;
    };

    const printBuyBankDate = () => {
        let html = null;
            html = (
                <Fragment>
                    <div className="o-layout__item u-1/2 u-p-none u-mt-none">
                        <p className="u-text-disabled u-mb-xsmall rema-text-overflow--ellipsis">
                            <span className="u-text-disabled">
                                {t.getTraduction('BuyDateBank')}
                            </span>
                        </p>
                        <p className="u-mb-xsmall">{vehicle.PayDateBank
                                            ? new Date(
                                                  isAppleDeviceOrNavegatorForDates(
                                                      vehicle.PayDateBank
                                                  )
                                              ).toLocaleDateString('en-GB')
                                            : '--'}</p>
                    </div>                   
                </Fragment>
            );       
        return html;
    };
    const printSellVWRDate = () => {
        let html = null;
            html = (
                <Fragment>
                    <div className="o-layout__item u-1/2 u-p-none u-mt-none">
                        <p className="u-text-disabled u-mb-xsmall rema-text-overflow--ellipsis">
                            <span className="u-text-disabled">
                                {t.getTraduction('PayDateVWR')}
                            </span>
                        </p>
                        <p className="u-mb-xsmall">{vehicle.PayDateVWR
                                                    ? new Date(
                                                          isAppleDeviceOrNavegatorForDates(
                                                              vehicle.PayDateVWR
                                                          )
                                                      ).toLocaleDateString('en-GB')
                                                    : '--'}</p>
                    </div>                   
                </Fragment>
            );       
        return html;
    };

    const printSellVWRDetailsData = () => {
        let html = null;
            html = (
                <Fragment>
                    <div className="o-layout__item u-1/2 u-p-none u-mt-none">
                        <p className="u-text-disabled u-mb-xsmall rema-text-overflow--ellipsis">
                            <span className="u-text-disabled">
                                {t.getTraduction('PenaltyForDismissalAutocredit')}
                            </span>
                        </p>
                        <p className="u-mb-xsmall">{formatPrice(vehicle.VMG*0.03)}</p>
                    </div>
                    <div className="o-layout__item u-1/2 u-p-none u-mt-none">
                        <p className="u-text-disabled u-mb-xsmall rema-text-overflow--ellipsis">
                            <span className="u-text-disabled">
                                {t.getTraduction('VehiclesellVWRPrice')}
                            </span>
                        </p>
                        <p className="u-mb-xsmall">{formatPrice(vehicle.VMG - vehicle.VMG*0.03 - vehicle.TotalDamageAmount)}</p>
                    </div>
                </Fragment>
            );       
        return html;
    };

    const printBuyType = () => {
        let text = '';
        switch (vehicle.CodeBuyType) {
            case 'P':
                text = t.getTraduction('Puja');
                break;
            case 'C':
                text = t.getTraduction('CompraDirecta');
                break;
            case 'R':
                text = t.getTraduction('dealerReceptor');
            default:
                break;
        }
        text = t.getTraduction('dealerReceptor');
        if (text == '') return null;
        return (
            <li className="list-inline__item">
                <Tag
                    classes={['c-vehicle-card__tag-payment-type']}
                    text={text}
                ></Tag>
            </li>
        );
    };

    const getImagesList = (typeList = false) => {
        if (typeList) return [getImageSource(vehicle.ImageSource)];
        return (
            <img
                src={getImageSource(vehicle.ImageSource)}
                onClick={() => setSelectedVehicle(vehicle)}
                alt="vehicle"
            />
        );
    };

    const printCardImageMobileVersion = () => {
        if (windowWidth > 720) return null;

        let optionsCarousel = {
            id: 'c-vehicle-card__carousel-' + vehicle.Id,
            next: true,
            images: getImagesList(true),
            flickity: {
                imagesLoaded: false,
            },
        };

        return (
            <div
                className="c-vehicle-card__carousel-container"
                onClick={() => setSelectedDetail()}
            >
                <Carousel
                    options={optionsCarousel}
                    onClickFunction={setSelectedDetail}
                />
                {/* tags */}
            </div>
        );
    };

    const printCardHeader = () => {
        if (windowWidth > 720) {
            return (
                <div className="o-layout">
                    <div className="o-layout__item u-1/1 u-p-none u-m-none">
                        <div className="c-vehicle-card__header-left-container">
                            {getImagesList()}
                        </div>
                        <div className="c-vehicle-card__header-right-container">
                            <div className="o-layout">
                                {printCardTitles()}
                                <div className="o-layout__item u-1/1 u-p-none u-mb-small">
                                    <ul className="list-inline">
                                        <li className="list-inline__item u-mr">
                                            <p className="u-m-none">
                                                {vehicle.RegistrationDate
                                                    ? vehicle.RegistrationDate +
                                                      ' | '
                                                    : null}
                                                {vehicle.Kms
                                                    ? formatNumber(
                                                          vehicle.Kms
                                                      ) + ' Km'
                                                    : null}
                                            </p>
                                        </li>
                                        {printBuyType()}
                                    </ul>
                                </div>
                                {printVehicleDates()}
                            </div>
                        </div>
                        {printCardTag()}
                    </div>
                </div>
            );
        } else {
            return (
                <div className="o-layout u-mb">
                    {printCardTitles()}
                    <div className="o-layout__item u-1/1">
                        <ul className="list-inline u-pl-small u-pr-small">
                            <li className="list-inline__item u-mr">
                                <p className="u-m-none">
                                    {vehicle.RegistrationDate
                                        ? vehicle.RegistrationDate + ' | '
                                        : null}
                                    {vehicle.Kms
                                        ? formatNumber(vehicle.Kms) + ' Km'
                                        : null}
                                </p>
                            </li>
                            {printBuyType()}
                        </ul>
                        {printVehicleDates(true)}
                    </div>
                </div>
            );
        }
    };

    return (
        <article
            id={
                'card-vehicle-' + (vehicle ? vehicle.IdVehicleAdjudication : '')
            }
            className={
                'c-card c-card--image c-vehicle-card c-vehicle-card--adjudged u-text-left ' +
                (vehicle.skeleton ? 'c-vehicle-card--skeleton' : '')
            }
        >
            {printCardImageMobileVersion()}
            <header
                className="c-card__header u-pb-none"
                onClick={setSelectedDetail}
            >
                {printCardHeader()}
            </header>
            <div className="c-card__body u-pl-none u-pr-none u-pt u-pt-none@s u-pb-none">
                <div className="o-layout o-layout--equal-height u-p-none">
                    <div className="o-layout__item u-2/5 u-2/6@l u-1/1@s first-cell">
                        <div className="o-layout">
                            <div className="o-layout__item u-1/1 u-p-none u-mt-none u-mb-small">
                                <p className="u-h6 u-mb-small">
                                    {t.getTraduction('InformationBuyBank')}
                                </p>
                            </div>
                            {printBuyBankDate()}                            
                            {printBuyBAnkDetailsData()}
                            
                        </div>
                    </div>
                    <div className="o-layout__item u-2/5 u-2/6@l u-1/1@s first-cell">
                        <div className="o-layout u-rema-full-weight">
                        <div className="o-layout__item u-1/1 u-p-none u-mt-none u-mb-small">
                                <p className="u-h6 u-mb-small">
                                    {t.getTraduction('InformationSellVWR')}
                                </p>
                            </div>
                            {printSellVWRDate()}
                            {printSellRegimeData()} 
                            {printSellVWRDetailsData()}
                                                      
                        </div>
                    </div>
                    <div className="o-layout__item u-1/5 u-2/6@l u-1/1@s second-cell">
                        <div className="o-layout u-rema-full-weight">
                            <div className="o-layout__item u-1/1 u-p-none u-mt-none">
                               {/* <Button
                                    options={optionsDownloadInvoiceVWR}
                                    onClick={() =>
                                        dowloadInvoiceVWR()
                                    }
                                ></Button>
                                <hr/>*/}
                                <Button
                                    options={optionsSchedulePickup}
                                    onClick={() =>
                                        openPickupModal()
                                    }
                                ></Button>
                                <hr/>
                                <Button
                                        options={optionsDownoadTransferDocuments}
                                        onClick={() =>
                                            openDocumentModal()
                                        }
                                    ></Button>
                                <Portal>
                                    <DetailsModal
                                        visible={error}
                                        large={false}
                                        onActionPress={() => setError(null)}
                                        onClose={() => setError(null)}
                                        title={t.getTraduction('DownloadDocumentationTitleError')}
                                        content={error?.Content}
                                        leftButton={t.getTraduction('Close')}
                                    />
                                </Portal>
                                {printModalDocuments()}
                                {printModalPickup()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </article>
    );
}

export default withCookies(VehicleSoldVWRCard);
